<template>
  <v-autocomplete
    v-model="selected"
    :items="options"
    :loading="loading"
    :disabled="loading"
    item-text="texto"
    item-value="perguntaId"
    label="Critério"
    placeholder="Critério"
    multiple
    clearable
    @change="emitChange"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>Nenhum critério encontrado</v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { perguntaAPI } from "@/modules/pergunta/API/Pergunta";

export default {
  name: "ComboboxPergunta",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: [],
      selected: this.value || [],
      loading: false,
    };
  },
  watch: {
    value(val) {
      this.selected = val || [];
    },
  },
  methods: {
    emitChange() {
      this.$emit("change", this.selected);
    },
    loadOptions() {
      this.loading = true;
      perguntaAPI
        .list()
        .then(({ data }) => {
          this.options = (data || []).map((item) => ({
            perguntaId: item.perguntaId,
            texto: item.texto,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadOptions();
  },
};
</script>
